var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"mClass":"main","data-title":"北京天蔚中医药发展促进中心-信息公开"}},[_c('mClass',{attrs:{"nav":_vm.nav}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }